import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/services/auth/jwt/auth.service';
import { environment } from 'src/environments/environment';
import { apiTokenHeader } from '@api/interfaces';

@Injectable()
export class JwtAuthInterceptor implements HttpInterceptor {

	constructor(private authService: AuthService) {}

	intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
		const isApiUrl = request.url.startsWith(environment.serverEndpoint);
		if (this.authService.isLoggedIn && isApiUrl) {
			request = request.clone({
				setHeaders: {
					...apiTokenHeader(this.authService.token)
				}
			});
		}
		return next.handle(request);
	}
}
